import React, { useEffect, useState } from 'react';
import i18n from 'i18n';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import useHttp from 'utils/hooks/useHttp';
import { getCurrentCountryRMI, getCurrentLanguageRMI } from 'utils/rmi/rmi-utils/rmi-utils';
import './ServiceNewsletter.scss';
import { generatePath, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ServiceNewsletterView from './ServiceNewsletter.view';

import {
  IVehicleManualItemMps,
  IVehicleManualList,
  IVehicleManualSubGroups
} from 'utils/rmi/interface/diagnostic.interface';
import Spinner from '../../../../../components/spinner/Spinner';
import ServiceNewsletterMobileView from './Mobile/ServiceNewsletterMobile.view';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import useReliableCatalogCarQueryParams from 'utils/hooks/useReliableCatalogCarQueryParams';
import { converObjectToParams } from 'utils/marketplace';

const ServiceNewsletter: React.FC = () => {

  const { isMobile } = useDeviceDetect();
  const { typeId } = useSelector((state: RootState) => state.tecrmi);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [sidebarDetails, setSidebarDetails] = useState(Number(searchParams.get('level')) || 1);
  const [loadingList, setLoadingList] = useState(false);

  const { vehicle_id } = useParams();
  const [manualList, setManualList] = useState<IVehicleManualList[]>([]);
  const [mainGroup, setMainGroup] = useState<IVehicleManualList>();
  const [subGroups, setSubGroups] = useState<IVehicleManualSubGroups>();
  const [itemMpsManual, setItemMpsManual] = useState<IVehicleManualItemMps>();
  const [activeItem, setActiveItem] = useState<number | string | undefined>();
  const [showModal, setShowModal] = useState(false);

  const [loadingHTML, setLoadingHTML] = useState(false);
  const carParams = useReliableCatalogCarQueryParams();


  const http = useHttp();

  const [iframeData, setIframeData] = useState<string>();

  const getList = (): void => {
    setLoadingList(true);
    http.serviceNewsletterHttp
      .fetchRMIVehicleManualsList({
        typeId: typeId,
        countryCode: getCurrentCountryRMI(i18n.language),
        languageCode: getCurrentLanguageRMI(i18n.language)
      })
      .then(({ data }) => {
        data.forEach((groups) => {
          groups.SubGroups.forEach((subgroups) => {
            subgroups.ItemMps.forEach((itemps) => {
              itemps.Manuals.forEach((element, index) => {
                element.activeId = itemps.ItemMpId + index;
              });
            });
          });
        });


        setManualList(data);
      })
      .finally(() => {
        setLoadingList(false);
      });
  };

  useEffect(() => {
    getList();
  }, [typeId, i18n.language]);


  function onMainGroupClick(item) {
    setMainGroup(item);
    setSidebarDetails(2);
    searchParams.set('main_group_id', item.MainGroupId);
    searchParams.set('level', '2');
    setSearchParams(searchParams);
  }

  function onSubGroupClick(item) {
    setSubGroups(item);
    setSidebarDetails(3);
    searchParams.set('sub_group_id', item.SubGroupId);
    searchParams.set('level', '3');
    setSearchParams(searchParams);
  }

  function onItemMpClick(item) {
    setItemMpsManual(item);
    setSidebarDetails(4);
    searchParams.set('level', '4');
    searchParams.set('item_id', item.ItemMpId);
    setSearchParams(searchParams);
  }

  function onItemMpManualClick(item) {
    setActiveItem(item.ManualId);
    searchParams.set('manual_id', item.ManualId);
    setSearchParams(searchParams);

    if (typeId && isMobile) {
      getHTML(item.ManualId);
    }
  }

  const getHTML = (manualId: number) => {
    setLoadingHTML(true);
    const param = {
      typeId,
      countryCode: getCurrentCountryRMI(i18n.language),
      languageCode: getCurrentLanguageRMI(i18n.language),
      printView: true,
      manualId: manualId ?? activeItem,
    };

    setLoadingHTML(true);
    http.manualsHttp.fetchRMIVehicleManualHtml(param)
      .then(({ data }) => {
        setIframeData(data);

      })
      .catch((e: Error) => console.log(e))
      .finally(() => {
        if (isMobile) {
          setShowModal(true);
        }

        setLoadingHTML(false);
      });
  };

  function onReturnClick() {
    if (sidebarDetails === 1) {
      navigate({
        pathname: generatePath('/reliable/rmi/:vehicle_id/technical-documentation', {
          vehicle_id: String(vehicle_id),
        }),
        search: converObjectToParams(carParams),
      });

      return;
    }

    //  navigate(-1);
    setSidebarDetails((prev) => prev - 1);
  }

  useEffect(() => {
    if (Number(searchParams.get('main_group_id')) && manualList) {
      setMainGroup(manualList?.find((item) => item.MainGroupId === Number(searchParams.get('main_group_id'))));
    }

    if (Number(searchParams.get('sub_group_id')) && mainGroup) {
      setSubGroups(mainGroup?.SubGroups.find((item) => item.SubGroupId === Number(searchParams.get('sub_group_id'))));
    }

    if (Number(searchParams.get('item_id')) && subGroups) {
      const item = subGroups?.ItemMps.find((item) => item.ItemMpId === Number(searchParams.get('item_id')));

      setItemMpsManual(item);
    }

    if (searchParams.get('manual_id') && itemMpsManual) {
      const item = itemMpsManual?.Manuals.find((item) => item.activeId === Number(searchParams.get('manual_id')));

      setActiveItem(item?.activeId);
    }

    if (searchParams.get('manual_id') && !searchParams.get('sub_group_id') && !searchParams.get('main_group_id') && manualList) {
      let isManualFound = false;

      for (const groups of manualList) {
        for (const subgroups of groups.SubGroups) {
          for (const itemps of subgroups.ItemMps) {
            for (const manual of itemps.Manuals) {
              if (manual.activeId == +searchParams.get('manual_id')!) {
                console.log(manual.activeId, searchParams.get('manual_id'));
                isManualFound = true;
                setSidebarDetails(4);

                break;
              }

              if (isManualFound) {
                setActiveItem(manual?.activeId);

                break;
              }
            }

            if (isManualFound) {
              setItemMpsManual(itemps);

              break;
            }
          }

          if (isManualFound) {
            setSubGroups(subgroups);

            break;
          }
        }

        if (isManualFound) {
          setMainGroup(groups);

          break;
        }
      }
    }
  }, [manualList, subGroups, mainGroup, itemMpsManual]);

  useEffect(() => {
    const manualIdUrl = Number(searchParams.get('manual_id'));

    if (manualIdUrl && typeId) {
      getHTML(manualIdUrl);
    }


  }, [searchParams.get('manual_id'), typeId]);

  return (
    <div className="technical-documentation-service-newsletter">
      {loadingList ? (
        <Spinner class="extra-small" />
      ) : (
        isMobile ?
          <ServiceNewsletterMobileView
            data={manualList}
            onMainGroupClick={onMainGroupClick}
            onSubGroupClick={onSubGroupClick}
            onItemMpClick={onItemMpClick}
            onItemMpManualClick={onItemMpManualClick}
            setOpenModal={setShowModal}
            activeItem={activeItem}
            showModal={showModal}
            loadingHTML={loadingHTML}
            iframeData={iframeData}
          />
          :
          <ServiceNewsletterView
            loadingList={loadingList}
            sidebarDetails={sidebarDetails}
            loadingHTML={loadingHTML}
            iframeData={iframeData}
            onMainGroupClick={onMainGroupClick}
            onSubGroupClick={onSubGroupClick}
            onItemMpClick={onItemMpClick}
            onManualClick={onItemMpManualClick}
            mainGroup={manualList}
            subGroup={mainGroup}
            itemMps={subGroups}
            itemMpsManual={itemMpsManual}
            activeItem={activeItem}
            onReturnClick={onReturnClick}
          />
      )}
    </div>
  );
};

export default ServiceNewsletter;